<template>
    <div class="chart-container">
      <canvas ref="chart"></canvas>
    </div>
  </template>
  
  <script>
  import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  
  Chart.register(ArcElement, Tooltip, Legend, ChartDataLabels);
  
  export default {
    name: 'PieChart',
    props: {
      chartData: {
        type: Object,
        required: true
      }
    },
    mounted() {
      this.renderChart();
    },
    watch: {
      chartData: {
        handler: 'renderChart',
        deep: true
      }
    },
    methods: {
      renderChart() {
        if (this.chart) {
          this.chart.destroy();
        }
  
        const ctx = this.$refs.chart.getContext('2d');
        this.chart = new Chart(ctx, {
          type: 'pie',
          data: this.chartData,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              duration: 500,
              easing: 'easeOutQuart'
            },
            plugins: {
              legend: {
                position: 'bottom',
                labels: {
                  font: {
                    size: 14
                  },
                  padding: 20
                }
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const label = context.label || '';
                    const value = context.parsed || 0;
                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                    const percentage = ((value / total) * 100).toFixed(1);
                    return `${label}: ${value} (${percentage}%)`;
                  }
                }
              },
              datalabels: {
                color: '#FFFFFF',
                font: {
                  weight: 'bold'
                },
                formatter: (value, ctx) => {
                  const total = ctx.dataset.data.reduce((a, b) => a + b, 0);
                  const percentage = ((value / total) * 100).toFixed(1);
                  return percentage + '%';
                }
              }
            }
          }
        });
      }
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.destroy();
      }
    }
  };
  </script>
  
  